export enum NinType {
  TYPE_REGULAR_NIN = 'TYPE_REGULAR_NIN',
  TYPE_D_NUMBER = 'TYPE_D_NUMBER',
  TYPE_H_NUMBER = 'TYPE_H_NUMBER',
  TYPE_NPR_SYNTHETIC = 'TYPE_NPR_SYNTHETIC'
}

export const ALL_NIN_TYPES = [
  NinType.TYPE_REGULAR_NIN,
  NinType.TYPE_D_NUMBER,
  NinType.TYPE_H_NUMBER,
  NinType.TYPE_NPR_SYNTHETIC
];
